export const VISITOR_UPLOADS_FOLDER_ID = 'visitor-uploads';

export const RCE_FAILED_UPLOAD_ID = 'rce-failed-upload-8975367367';
